export default __webpack_public_path__ + "static/media/ArrowCircleright.dd5bb30a.svg";